<template>
  <div class="animated fadeIn">
    <b-card :header="this.pregResult.exPreg.preg.name+' 결과'">
      <b-card header="예약자 파일 다운로드 (개발사 공유용)">
        <b-button variant="outline-primary" type="button" v-if="pregResult.exPreg.gameStudioShareFile" :href="pregResult.exPreg.gameStudioShareFile !== null ? pregResult.exPreg.gameStudioShareFile[0].s3DownloadLink :''">다운로드</b-button>
        <span v-else>다운로드 파일 없음</span>

        <div class="mt-3">
          <div>
            <p>[SDK 3.0 탑재 게임 다운로드 파일 제공 포맷]
              <br>
              memberkey | 사전예약 일자 | marketType
            </p>
            <br>
            <p>[SDK 1.0/2.0 탑재 게임 다운로드 파일 제공 포맷]
              <br>
              service user id | 사전예약 일자 | marketType
            </p>
          </div>
        </div>

        <div class="mt-3">
          <p class="mb-0 highlight">- 파일 다운로드는 사전예약 종료일로부터 7일 동안만 가능합니다.</p>
          <p class="mb-0 highlight">- 사전예약 이용자 정보 파기 기한은 전자계약서 전달 후 5일 내 입니다.</p>
          <p class="mb-0 highlight">- 사전예약 종료 후, 이용자 정보 파기 확약서를 반드시 전달해 주세요.</p>
          <p class="mb-0 highlight">- 파일이 정상적으로 생성되지 않은 경우 어드민관리자에게 문의해주세요.</p>
        </div>
      </b-card>
      <b-card header="공유하기 이벤트 결과 다운로드 (개발사 공유용)">
        <b-button variant="outline-primary" type="button" v-if="pregResult.exPreg.inviterFile" :href="pregResult.exPreg.inviterFile !== null ? pregResult.exPreg.inviterFile[0].s3DownloadLink :''">다운로드</b-button>
        <span v-else>다운로드 파일 없음</span>
        <br>

        <div class="mt-3">
          <div>
            <p>[SDK 3.0 탑재 게임 다운로드 파일 제공 포맷]
              <br>
              memberkey | 내 공유 링크로 예약한 친구 수 | 친구의 memberkey | marketType
            </p>
            <br>
            <p>[SDK 1.0/2.0 탑재 게임 다운로드 파일 제공 포맷]
              <br>
              service user id | 내 공유 링크로 예약한 친구 수 | 친구의 service user id | marketType
            </p>
          </div>
        </div>

        <div class="mt-3">
          <p class="mb-0 highlight">- 파일 다운로드는 사전예약 종료일로부터 7일 동안만 가능합니다.</p>
          <p class="mb-0 highlight">- 사전예약 이용자 정보 파기 기한은 전자계약서 전달 후 5일 내 입니다.</p>
          <p class="mb-0 highlight">- 사전예약 종료 후, 이용자 정보 파기 확약서를 반드시 전달해 주세요.</p>
          <p class="mb-0 highlight">- 파일이 정상적으로 생성되지 않은 경우 어드민관리자에게 문의해주세요.</p>
        </div>
      </b-card>

      <b-card header="사전예약 지표 (개발사 공유용)">
        <p class="info">실시간 예약자 수 / 실시간 OS별 예약자 수 / 실시간 공유하기를 통한 예약자 수 / 일별 예약자 수를 조회할 수 있습니다.</p>
        <p v-if="isInhouseLogin()">
          닉네임선점 지표는 브랜드 어드민에서 확인가능합니다. <b-link :href="brandAdminAddr" target="_blank">바로가기 -></b-link>
        </p>
        <strong> 사전예약자수  </strong> : {{pregResult.totalCount}}
        <br>
        <strong> GooglePlay  </strong> : {{pregResult.googlePlayCount}}
        <br>
        <strong> AppStore  </strong> : {{pregResult.appStoreCount}}
        <br>
        <strong> 실시간 공유하기를 통한 예약자 수 </strong> : {{pregResult.invitedUserCount}}
        <br>
        <b-table class="mt-3" hover striped bordered small fixed responsive="sm" :items="pregUserLogListSortedByDate" :fields="indicatorFields" :show-empty=true empty-text="리스트가 없습니다." v-if="pregResult.pregUserLogList != null">
        </b-table>
      </b-card>
      <b-card header="예약자 파일 다운로드 (출시알림 메시지 발송용)" v-if="isInhouseLogin()">
        <p class="info d-inline-block">출시알림 메시지 발송일을 등록하면 다운로드 버튼이 출력됩니다.</p>
        <b-button class="ml-2" variant="outline-primary" type="button" @click="tmsModal.isShow=true">출시알림 발송일 등록</b-button>
        <hr>
        <div class="d-inline-block align-middle">
          <b-button class="ml-2" variant="outline-primary" type="button" :href="pregResult.exPreg.tmsFile !== null ? pregResult.exPreg.tmsFile[0].s3DownloadLink :''" v-if="pregResult.exPreg.tmsFile && isRegTmsSendingTime">다운로드</b-button>
        </div>
      </b-card>

      <b-card header="예약자 파일 중간 추출 (내부용)" v-if="isInhouseLogin()">
        <b-form-group
          label="시작"
          label-for="startTime" :horizontal="true" :label-cols="1" invalid-feedback="예약 기간을 설정해주세요.">
          <date-picker id="startTime" :value="intermediateStartTime" v-on:input="intermediateStartTime = new Date($event)" :config="dateOptions"></date-picker>
        </b-form-group>
        <b-form-group
          label="종료"
          label-for="endTime" :horizontal="true" :label-cols="1" invalid-feedback="예약 기간을 설정해주세요.">
          <date-picker id="endTime" :value="intermediateEndTime" v-on:input="intermediateEndTime = new Date($event)" :config="endOptions"></date-picker>
        </b-form-group>
        <b-button variant="outline-primary" type="button" @click="reqCreateMiddleFile">추출 요청</b-button>
        <br>
        <br>
        <strong v-if="pregResult.exPreg.middleFiles">
          다운로드 리스트
        </strong>
          <p v-for="item in pregResult.exPreg.middleFiles" :key="item.s3FileKey">
            <a :href="item.s3DownloadLink">{{item.s3FileKey}}</a>
          </p>
        <p>
          [다운로드 파일 제공 포맷]
          <br>
          파일 1) 예약자 파일 중간 추출(내부용)
          <br>
          memberkey | service user id | account id | 사전예약 일자 | marketType
          <br><br>
          파일 2) 공유하기 이벤트 결과 파일(내부용)
          <br>
          1/3/5/10/20/30명 구간으로 나눠서 제공
          <br>
          account id | memberkey(SDK 3.0) or service user id(SDK 1.0/2.0) | 사전예약 일자 | 내 공유 링크로 예약한 친구 수 | 친구의 memberkey(SDK 3.0) or service user id(SDK 1.0/2.0) | marketType
        </p>
      </b-card>

      <b-card header="이모티콘 대량 발송 (내부용)" v-if="isInhouseLogin() && this.pregResult.exPreg.preg.etcInfo.emoticonApiKey && (this.auth.authGroup.authGroupName === '마케터' || this.auth.authGroup.authGroupName === 'super' || this.auth.authGroup.authGroupName === 'developer')">
        <b-form-group
                label="시작"
                label-for="eStartTime" :horizontal="true" :label-cols="1" invalid-feedback="기간을 설정해주세요.">
          <date-picker id="eStartTime" :value="emoticonStartTime" v-on:input="emoticonStartTime = new Date($event)" :config="dateOptions"></date-picker>
        </b-form-group>
        <b-form-group
                label="종료"
                label-for="eEndTime" :horizontal="true" :label-cols="1" invalid-feedback="기간을 설정해주세요.">
          <date-picker id="eEndTime" :value="emoticonEndTime" v-on:input="emoticonEndTime = new Date($event)" :config="endEmoticonOptions"></date-picker>
        </b-form-group>
        <b-button variant="outline-primary" type="button" @click="reqSendEmoticons">전송 요청</b-button>
      </b-card>

      <b-card :header="this.pregResult.exPreg.preg.name+' 예약자 리스트'" v-if="isInhouseLogin()">
        <p class="info">{{ pregResult.exPreg.preg.appInfo.appName }}의 사전예약자를 조회하거나 예약을 취소할 수 있어요.</p>

        <div>
          <b-form-select v-model="idOptionSelected" :options="idOptions" class="mb-3" style="float:left; width: 200px"></b-form-select>
          <div style="overflow: hidden;">
            <b-form-input type="text" autocomplete="id" placeholder="아이디로 검색" v-model="idInputted" style="float:left; width: 400px"></b-form-input>
            <b-button variant="outline-primary" type="button" @click="getPregUserInfoById" style="float: left;">검색</b-button>
          </div>
        </div>

        <b-table hover striped bordered small fixed responsive="sm" :items="pregUserInfoItem" :fields="pregUserInfofields" :current-page="currentPage" :per-page="perPage" :show-empty=true empty-text="결과가 없습니다.">
          <!--<template slot="index" slot-scope="data">-->
            <!--{{data.index + 1}}-->
          <!--</template>-->
          <template slot="share" slot-scope="data">
            {{data.item.shareCount}} <b-button type="button" v-if="data.item.shareList !== null && data.item.shareList.length > 0" @click="showUserShareInfo(data.item)">[자세히]</b-button>
          </template>
          <template slot="regTime" slot-scope="data">
            {{data.item.regTime.format('YY.MM.DD HH:mm')}}
          </template>
          <template slot="management" slot-scope="data">
            <!--<b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>-->
            <b-link @click="cancelReservation(data.item)" class="mr-2">[예약 취소]</b-link>
            <b-link @click="resendEmoticon(data.item)">[이모티콘 재전송]</b-link>
          </template>
        </b-table>

      </b-card>
      <div v-if="isInhouseLogin()" style="position: relative;">
        <b-template v-if="this.auth.authGroup.authGroupName === 'super' || this.auth.authGroup.authGroupName === 'developer'">
          <b-button variant="warning" v-on:click="reqPregFinishFile">예약자 파일 생성 요청</b-button>
          <b-button variant="warning" v-on:click="reqPregInviteFile" class="ml-3">공유하기 이벤트 결과 파일 생성 요청</b-button>
        </b-template>
        <span v-if="this.pregResult.exPreg.preg.etcInfo.emoticonApiKey">
          <b-button variant="warning" v-on:click="getUserListFailedToSendEmoticon" class="ml-3">이모티콘 지급 실패 현황 확인</b-button>
        </span>
        <p class="mb-0 highlight" style="position: absolute; bottom: -24px;">- 사전예약 종료 전 파일생성시 외부계정에 노출되니 요청 전 종료여부 확인해주세요</p>
      </div>
      <b-button block variant="outline-secondary" class="mt-5" v-on:click="$router.go(-1)">뒤로</b-button>
    </b-card>

    <b-modal v-model="tmsModal.isShow" title="출시알림 발송일 등록 (내부용)" ok-title="등록 완료" cancel-title="닫기" centered no-close-on-esc no-close-on-backdrop hide-header-close @ok="tmsModal.okHandling">
      <div v-if="isGooglePlayReleased">
        <b-form-group
          label="Google Play"
          label-for="startTime" :horizontal="true" :label-cols="3">
          <date-picker id="startTime" :value="googlePlayTmsTime" v-on:input="googlePlayTmsTime = new Date($event)" :config="dateOptions"></date-picker>
        </b-form-group>
      </div>
      <div v-if="isAppStoreReleased">
        <b-form-group
          label="App Store"
          label-for="endTime" :horizontal="true" :label-cols="3">
          <date-picker id="endTime" :value="appStoreTmsTime" v-on:input="appStoreTmsTime = new Date($event)" :config="dateOptions"></date-picker>
        </b-form-group>
      </div>
      <hr>
      <p class="info">
        등록한 날짜 기준으로 사전예약 가입/로그인 전환 지표가 추출됩니다.
        <br>
        출시알림 발송일 미등록 / 오등록시 책임지지 않습니다.
      </p>
    </b-modal>

    <b-modal v-model="shareInfoModal.isShow" title="공유하기 성과" ok-title="닫기" centered no-close-on-esc no-close-on-backdrop hide-header-close ok-only close @ok="shareInfoModal.okHandling">
      <div>
        <b-form-select v-model="shareInfoModal.idOptionSelected" :options="shareInfoModal.idOptions" class="mb-3" style="float:left; width: 200px"></b-form-select>
        <div style="overflow: hidden;">
          <b-form-input type="text" autocomplete="id" placeholder="아이디로 검색" v-model="shareInfoModal.shareUserIdInputted" style="float:left; width: 400px"></b-form-input>
        </div>
      </div>
      <b-table hover striped bordered small fixed responsive="sm" :items="filteredShareInfoList" :fields="shareInfoModal.fields" :current-page="shareInfoModal.currentPage" :per-page="shareInfoModal.perPage" :show-empty=true empty-text="결과가 없습니다.">
      </b-table>
      <nav>
        <b-pagination :total-rows="filteredShareInfoList.length" :per-page="shareInfoModal.perPage" v-model="shareInfoModal.currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
      </nav>
    </b-modal>
  </div>
</template>
<script>
import { MODULE_NAME as PREG_MODULE, FETCH_PREG_RESULT } from '@/store/preg/actions.type'
import { mapState, mapMutations } from 'vuex'
import pregService from '@/common/api/preg.service'
import { $isInhouseLogin, $showModalWithErrorMsg } from '@/common/util'
import { SHOW_MODAL } from '@/store/ui/mutations.type'
import { emoticonResendDesc } from '@/constants'
import moment from "moment"
const SERVICE_USER_ID = 'serviceUserId'
const ACCOUNT_ID = 'accountId'
const ACCOUNT_KEY = 'accountKey'
const MEMBER_KEY = 'memberKey'
export default {
  data () {
    return {
      brandAdminAddr: process.env.VUE_APP_BRAND_ADMIN_ADDR,
      idOptionSelected: ACCOUNT_ID,
      idOptions: [{
        value: ACCOUNT_ID,
        text: 'Account Id'
      }, {
        value: MEMBER_KEY,
        text: 'Member Key'
      }],
      idInputted: '',
      isInhouseLogin: $isInhouseLogin.bind(this),
      isSdk3: true,
      googlePlayTmsTime: null,
      appStoreTmsTime: null,
      intermediateStartTime: null,
      intermediateEndTime: null,
      emoticonStartTime: null,
      emoticonEndTime: null,
      dateOptions: {
        format: 'YYYY-MM-DD HH:mm:ss',
        useCurrent: true
      },
      tmsModal: {
        isShow: false,
        okHandling: () => {
          this.pregResult.exPreg.preg.marketInfoList.forEach((element) => {
            element.benefitInfo = JSON.stringify(element.benefitInfo)
          })
          pregService.updateTmsSendingTime(this.pregResult.exPreg.preg.marketInfoList)
            .then(()=> {
              this[SHOW_MODAL]({msg: '등록하였습니다.', okHandling: () => {}})
            })
            .catch($showModalWithErrorMsg.bind(this))
        }
      },
      shareInfoModal: {
        idOptionSelected: ACCOUNT_KEY,
        idOptions: [
          {
            value: ACCOUNT_KEY,
            text: 'Account Key'
          }
        ],
        shareUserIdInputted: '',
        isShow: false,
        shareInfoList: [],
        perPage: 5,
        currentPage: 1,
        okHandling: () => {},
        fields: [
          {key: 'accountKey', label: 'accountKey', class: 'align-middle text-center'},
          {key: 'serviceUserId', label: 'serviceUserId', class: 'align-middle text-center'}
        ]
      },
      // 결과 값은 항상 1개지만, b-table 쓰기위해..
      pregUserInfoItem: [],
      pregUserInfofields: [
        {key: 'seq', label: '순번', class: 'align-middle text-center'},
        {key: 'marketType', label: '마켓', class: 'align-middle text-center'},
        {key: 'accountId', label: 'account id', class: 'align-middle text-center'},
        {key: 'memberKey', label: 'memberkey', class: 'align-middle text-center'},
        {key: 'serviceUserId', label: 'service user id', class: 'align-middle text-center'},
        {key: 'regTime', label: '예약 신청 일자', class: 'align-middle text-center', thStyle: {width: '125px'}},
        {key: 'share', label: '공유하기 성과', class: 'align-middle text-center', thStyle: {width: '125px'}},
        {key: 'management', label: '사전예약 관리', class: 'align-middle text-center'}
      ],
      indicatorFields: [
        {
          key: 'logDate',
          label: '일자',
          class: 'align-middle text-center'
        },
        {
          key: 'pregUserCnt',
          label: '사전예약자 수',
          class: 'align-middle text-center'
        },
        {
          key: 'pregInvitedUserCnt',
          label: '초대로 예약한 사전예약자수',
          class: 'align-middle text-center'
        }
      ],
      currentPage: 1,
      perPage: 5
    }
  },
  mounted () {
    this.$store.dispatch(PREG_MODULE + FETCH_PREG_RESULT, this.$route.params.pregId)
      .then(()=> {
        this.emoticonStartTime = new Date(this.pregResult.exPreg.preg.startTime);
        this.emoticonEndTime = new Date(this.pregResult.exPreg.preg.endTime);

        for (let i = 0; i < this.pregResult.exPreg.preg.marketInfoList.length; i++) {
          const tmsSendingTime = this.pregResult.exPreg.preg.marketInfoList[i].tmsSendingTime
          // 등록되지 않으면 null이다.
          if (tmsSendingTime) {
            // unixTime을 Date으로 변경하기 위함.
            // datepicker에서는 unixtime을 인식하지 못한다.
            if (this.pregResult.exPreg.preg.marketInfoList[i].marketType === 'googlePlay') {
              this.googlePlayTmsTime = new Date(tmsSendingTime)
            }
            else if (this.pregResult.exPreg.preg.marketInfoList[i].marketType === 'appStore') {
              this.appStoreTmsTime = new Date(tmsSendingTime)
            }
          }
        }
      })
      .catch($showModalWithErrorMsg.bind(this))
  },
  computed: {
    endOptions () {
      return Object.assign({}, this.dateOptions, {minDate: this.intermediateStartTime})
    },
    endEmoticonOptions () {
      return Object.assign({}, this.dateOptions, {minDate: this.emoticonStartTime})
    },
    isGooglePlayReleased () {
      for (let i = 0; i < this.pregResult.exPreg.preg.marketInfoList.length; i++) {
        if (this.pregResult.exPreg.preg.marketInfoList[i].marketType === 'googlePlay') {
          return true
        }
      }
      return false
    },
    isAppStoreReleased () {
      for (let i = 0; i < this.pregResult.exPreg.preg.marketInfoList.length; i++) {
        if (this.pregResult.exPreg.preg.marketInfoList[i].marketType === 'appStore') {
          return true
        }
      }
      return false
    },
    filteredShareInfoList () {
      return this.shareInfoModal.shareInfoList.filter((elem) => {
        if (this.shareInfoModal.idOptionSelected === SERVICE_USER_ID) {
          return elem.serviceUserId.includes(this.shareInfoModal.shareUserIdInputted)
        } else if (this.shareInfoModal.idOptionSelected === ACCOUNT_KEY){
          return elem.accountKey.includes(this.shareInfoModal.shareUserIdInputted)
        } else {
          return false
        }
      })
    },
    pregUserLogListSortedByDate () {
      return this.pregResult.pregUserLogList.sort((a, b) => {
        return b.logDate.localeCompare(a.logDate)
      })
    },
    isRegTmsSendingTime () {
      for (let i = 0; i < this.pregResult.exPreg.preg.marketInfoList.length; i++ ) {
        if (this.pregResult.exPreg.preg.marketInfoList[i].tmsSendingTime !== null) {
          return true
        }
      }
      return false
    },
    ...mapState(PREG_MODULE, [
      'pregResult'
    ]),
    ...mapState('auth', [
      'auth'
    ])
  },
  watch: {
    googlePlayTmsTime () {
      for (let i = 0; i < this.pregResult.exPreg.preg.marketInfoList.length; i++) {
        if (this.pregResult.exPreg.preg.marketInfoList[i].marketType === 'googlePlay') {
          this.pregResult.exPreg.preg.marketInfoList[i].tmsSendingTime = this.googlePlayTmsTime
          return
        }
      }
    },
    appStoreTmsTime () {
      for (let i = 0; i < this.pregResult.exPreg.preg.marketInfoList.length; i++) {
        if (this.pregResult.exPreg.preg.marketInfoList[i].marketType === 'appStore') {
          this.pregResult.exPreg.preg.marketInfoList[i].tmsSendingTime = this.appStoreTmsTime
          return
        }
      }
    },
    'pregResult.exPreg.preg.appInfo.appSdkVer': {
      handler (newVal, oldVal) {
        // sdk 1.0이나 2.0에서 serviceUserId로 검색할 수 있다.
        const serviceUserIdOption = {
          value: SERVICE_USER_ID,
          text: 'Service User Id'
        }
        // sdk 3.0 기반 게임들은 memberKey로 검색할 수 있다.
        // const memberKeyIdOption = {
        //   value: MEMBER_KEY,
        //   text: 'Member Key'
        // }
        if (newVal !== null && newVal !== '') {
          this.resetIdOptions()
          this.idOptions.unshift(serviceUserIdOption)
          this.shareInfoModal.idOptions.unshift(serviceUserIdOption)
          this.isSdk3 = false
        }
      },
      immediate: true
    }
  },
  methods: {
    resetIdOptions () {
      this.idOptions = [{
        value: ACCOUNT_ID,
        text: 'Account Id'
      }]
    },
    resetPregUserInfo () {
      this.pregUserInfoItem = []
    },
    getPregUserInfoById () {
      let pregUserDto = {
        pregMasterId: this.$route.params.pregId
      }
      if (this.idOptionSelected === SERVICE_USER_ID) {
        pregUserDto.serviceUserId = this.idInputted
      } else if (this.idOptionSelected === ACCOUNT_ID) {
        pregUserDto.accountId = this.idInputted
      } else if (this.idOptionSelected === MEMBER_KEY) {
        pregUserDto.memberKey = this.idInputted
      }
      pregService.getPregUserInfoById(pregUserDto)
        .then(({data}) => {
          console.log(data)
          console.log(typeof data)
          console.log(data ===null)
          console.log(data == {})
          this.resetPregUserInfo()
          if (data) {
            data.regTime  = moment(data.regTime)
            this.pregUserInfoItem.push(data)
          }
        })
        .catch($showModalWithErrorMsg.bind(this))
    },
    reqPregFinishFile () {
      let reqFileDto = {
        pregMasterId: this.$route.params.pregId,
        appMasterId: this.$route.params.appMasterId
      }
      pregService.reqPregFinishFile(reqFileDto)
        .then((res) => {
          this[SHOW_MODAL]({msg: '사전예약 완료 파일 생성을 요청하였습니다. (추출이 완료되면 카카오톡 메시지가 전송됩니다.)', okHandling: () => {}})
        })
        .catch($showModalWithErrorMsg.bind(this))
    },
    reqPregInviteFile () {
      let reqFileDto = {
        pregMasterId: this.$route.params.pregId,
        appMasterId: this.$route.params.appMasterId
      }
      pregService.reqPregInviteFile(reqFileDto)
        .then((res) => {
          this[SHOW_MODAL]({msg: '사전예약 초대자 파일 생성 요청하였습니다. (추출이 완료되면 카카오톡 메시지가 전송됩니다.)', okHandling: () => {}})
        })
        .catch($showModalWithErrorMsg.bind(this))
    },
    reqCreateMiddleFile () {
      if (this.intermediateStartTime === null || this.intermediateEndTime === null) {
        this[SHOW_MODAL]({msg: '예약자 파일 중간 추출 날짜를 설정해주세요.', okHandling: () => {}})
        return
      }
      let middleFileDto = {
        pregMasterId: this.$route.params.pregId,
        appMasterId: this.$route.params.appMasterId,
        startTime: this.intermediateStartTime,
        endTime: this.intermediateEndTime
      }
      pregService.createMiddleFile(middleFileDto)
        .then((res) => {
          this[SHOW_MODAL]({msg: '예약자 파일 중간 추출을 요청하였습니다. (추출이 완료되면 카카오톡 메시지가 전송됩니다.)', okHandling: () => {}})
        })
        .catch($showModalWithErrorMsg.bind(this))
    },
    reqSendEmoticons () {
      if (this.emoticonStartTime == null || this.emoticonEndTime == null) {
        this[SHOW_MODAL]({msg: '이모티콘을 재발송할 기간을 설정해주세요.', okHandling: () => {}})
        return
      }
      let sendingEmoticonDto = {
        pregMasterId: this.$route.params.pregId,
        startTime: this.emoticonStartTime,
        endTime: this.emoticonEndTime
      }
      pregService.reqSendEmoticons(sendingEmoticonDto)
              .then((res) => {
                this[SHOW_MODAL]({msg: '이모티콘 전송을 요청하였습니다. (전송이 완료되면 카카오톡 메시지가 전송됩니다.)', okHandling: () => {}})
              })
              .catch($showModalWithErrorMsg.bind(this))
    },
    showUserShareInfo (pregUserInfo) {
      this.shareInfoModal.shareInfoList = pregUserInfo.shareList
      this.shareInfoModal.isShow = true
    },
    cancelReservation (pregUserInfo) {

      const res = confirm('예약 취소하시겠습니까?')
      console.log(pregUserInfo)
      if (res) {
        pregService.cancelReservation({seq: pregUserInfo.seq, pregMasterId: this.$route.params.pregId, accountId: pregUserInfo.accountId})
          .then(({data}) => {
            this.resetPregUserInfo()
            this[SHOW_MODAL]({msg: '취소하였습니다.', okHandling: () => {}})
          })
          .catch($showModalWithErrorMsg.bind(this))
      }
    },
    resendEmoticon(pregUserInfo) {
      if (pregUserInfo.kakaoRewardApiKey === null || pregUserInfo.kakaoRewardApiKey.trim() === '') {
        alert('이모티콘 API키가 없습니다.')
        return;
      }
      if (pregUserInfo.accountKey === null || pregUserInfo.accountKey.trim() === '') {
        alert('account Key가 없습니다.')
        return;
      }
      pregService.resendEmoticon({
        accountKey: pregUserInfo.accountKey,
        kakaoRewardApiKey: pregUserInfo.kakaoRewardApiKey
      }).then(({data}) => {
          if (emoticonResendDesc[data.detailCode] !== undefined) {
            this[SHOW_MODAL]({msg: `재전송 요청하였습니다..( 결과 : ${emoticonResendDesc[data.detailCode]['ko']})`, okHandling: () => {}})
          } else {
            this[SHOW_MODAL]({msg: `재전송 요청하였습니다..( 결과 : unknown)`, okHandling: () => {}})
          }
        })
        .catch($showModalWithErrorMsg.bind(this))
    },
    resendAllEmoticonFailed () {
      pregService.resendAllEmoticonFailed(this.$route.params.pregId)
        .then(({data}) => {
          this[SHOW_MODAL]({msg: data.msg, okHandling: () => {}})
        })
        .catch((err) => {
          if (err.response.data.msg) {
            this[SHOW_MODAL]({msg: err.response.data.msg, okHandling: () => {}})
          } else {
            throw err
          }
        })
        .catch($showModalWithErrorMsg.bind(this))
    },
    getUserListFailedToSendEmoticon () {
      pregService.getUserListFailedToSendEmoticon(this.$route.params.pregId)
        .then(({data}) => {
          let msg = 'preg_benefit_error_log count group by status =>'
          for (let i = 0; i < data.statusList.length; i++) {
              msg += '  *' + data.statusList[i].status + ' : ' + data.statusList[i].cnt
          }
          this[SHOW_MODAL]({msg: msg, okHandling: () => {}})
        })
        .catch((err) => {
          if (err.response.data.msg) {
            this[SHOW_MODAL]({msg: err.response.data.msg, okHandling: () => {}})
          } else {
            throw err
          }
        })
        .catch($showModalWithErrorMsg.bind(this))
    },
    ...mapMutations('ui', [SHOW_MODAL])
  }
}
</script>
<style scoped>
.highlight {
  color: #dc2e38
}
.info {
  color: #84868a;
}
</style>
